import { Tag, Typography } from 'antd';

export interface VocabHintData {
  slug: string | null;
  keywords?: string[];
}

/**
 * 뜻 확인 힌트: 슬러그(영문)와 키워드. 표기만으로 뜻이 모호한 어휘(눈 eye/snow, 배 belly/pear/boat)가
 * 제대로 생성됐는지 판단하는 데 쓴다.
 */
export function VocabHint({ hint, max = 4 }: { hint: VocabHintData | undefined; max?: number }) {
  if (!hint) return null;
  const kw = hint.keywords ?? [];
  if (!hint.slug && !kw.length) return null;
  return (
    <span data-testid="vocab-hint" style={{ fontSize: 12, fontWeight: 'normal' }}>
      {hint.slug && <Typography.Text code>{hint.slug}</Typography.Text>}
      {kw.slice(0, max).map((k) => (
        <Tag key={k} bordered={false} style={{ marginInlineEnd: 4, fontSize: 12 }}>{k}</Tag>
      ))}
      {kw.length > max && <Typography.Text type="secondary">+{kw.length - max}</Typography.Text>}
    </span>
  );
}
